import { render, staticRenderFns } from "./PcParts.vue?vue&type=template&id=34253153&"
import script from "./PcParts.vue?vue&type=script&lang=js&"
export * from "./PcParts.vue?vue&type=script&lang=js&"
import style0 from "./PcParts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports